import React from 'react';
import { Avatar, Box, Typography } from '@mui/material';
import { formatProjectUpdatedLabel } from '../../../constants/projectCategories';
import { getUserInitials } from '../../../utils/userUtils';
import { discoveryMetaSx } from './discoveryCardStyles';

const compactCount = (value) => {
  const count = Number(value) || 0;
  if (count >= 1000) return `${(count / 1000).toFixed(count >= 10000 ? 0 : 1).replace(/\.0$/, '')}k`;
  return String(count);
};

export default function DiscoveryCardMetadata({ authorName, author, uses = 0, favorites = 0, updatedAt, trailing }) {
  const updatedLabel = formatProjectUpdatedLabel(updatedAt);
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1, mt: 0.25, minWidth: 0 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minHeight: 24 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'rgb(100, 116, 139)', fontSize: '0.75rem' }}>
          <span>{compactCount(uses)} Uses</span>
          {Number(favorites) > 0 && <>
          <Box component="span" sx={{ color: 'rgb(203, 213, 225)' }}>·</Box>
          <span>{compactCount(favorites)} Favorites</span>
          </>}
        </Box>
        {trailing && <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>{trailing}</Box>}
      </Box>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1, minWidth: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.625, minWidth: 0 }}>
          <Avatar sx={{ width: 20, height: 20, fontSize: '0.59375rem', bgcolor: 'rgba(29, 78, 216, 0.12)', color: 'primary.main' }}>
            {getUserInitials(author || { name: authorName })}
          </Avatar>
          <Typography component="span" noWrap sx={{ fontSize: '11.5px', fontWeight: 500, color: 'rgb(100, 116, 139)' }}>
            {authorName}
          </Typography>
        </Box>
        {updatedLabel && <Typography component="span" noWrap sx={{ ...discoveryMetaSx, flexShrink: 0 }}>Updated {updatedLabel}</Typography>}
      </Box>
    </Box>
  );
}
